/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetSidebarState200ResponseDataApplicationsApplicationsByType } from './GetSidebarState200ResponseDataApplicationsApplicationsByType'
import {
  GetSidebarState200ResponseDataApplicationsApplicationsByTypeFromJSON,
  GetSidebarState200ResponseDataApplicationsApplicationsByTypeFromJSONTyped,
  GetSidebarState200ResponseDataApplicationsApplicationsByTypeToJSON,
} from './GetSidebarState200ResponseDataApplicationsApplicationsByType'

/**
 * Количество заявлений с разбивкой по типам
 * @export
 * @interface GetSidebarState200ResponseDataApplications
 */
export interface GetSidebarState200ResponseDataApplications {
  /**
   * Суммарное количество заявлений всех типов
   * @type {number}
   * @memberof GetSidebarState200ResponseDataApplications
   */
  applications: number
  /**
   *
   * @type {GetSidebarState200ResponseDataApplicationsApplicationsByType}
   * @memberof GetSidebarState200ResponseDataApplications
   */
  applicationsByType: GetSidebarState200ResponseDataApplicationsApplicationsByType
}

/**
 * Check if a given object implements the GetSidebarState200ResponseDataApplications interface.
 */
export function instanceOfGetSidebarState200ResponseDataApplications(
  value: object
): value is GetSidebarState200ResponseDataApplications {
  if (!('applications' in value) || value['applications'] === undefined)
    return false
  if (
    !('applicationsByType' in value) ||
    value['applicationsByType'] === undefined
  )
    return false
  return true
}

export function GetSidebarState200ResponseDataApplicationsFromJSON(
  json: any
): GetSidebarState200ResponseDataApplications {
  return GetSidebarState200ResponseDataApplicationsFromJSONTyped(json, false)
}

export function GetSidebarState200ResponseDataApplicationsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSidebarState200ResponseDataApplications {
  if (json == null) {
    return json
  }
  return {
    applications: json['applications'],
    applicationsByType:
      GetSidebarState200ResponseDataApplicationsApplicationsByTypeFromJSON(
        json['applicationsByType']
      ),
  }
}

export function GetSidebarState200ResponseDataApplicationsToJSON(
  value?: GetSidebarState200ResponseDataApplications | null
): any {
  if (value == null) {
    return value
  }
  return {
    applications: value['applications'],
    applicationsByType:
      GetSidebarState200ResponseDataApplicationsApplicationsByTypeToJSON(
        value['applicationsByType']
      ),
  }
}
